module.exports = require('./DepCreditUnionLocationActivitiesFilingView');
